export const ModalContentIdConst = 'giftmio-modal';
